"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var InputSearch_1 = require("../Primitives/InputSearch");
var __1 = require("..");
var SearchField = function (_a) {
    var id = _a.id, _b = _a.disabled, disabled = _b === void 0 ? false : _b, placeholder = _a.placeholder, _c = _a.reversed, reversed = _c === void 0 ? false : _c, loading = _a.loading, secondary = _a.secondary, value = _a.value, labelText = _a.labelText, onClear = _a.onClear, genericInputProps = __rest(_a, ["id", "disabled", "placeholder", "reversed", "loading", "secondary", "value", "labelText", "onClear"]);
    var showVisibleLabel = !secondary;
    return (react_1["default"].createElement(__1.FieldGroup, { inline: false },
        showVisibleLabel && (react_1["default"].createElement(__1.Label, { htmlFor: id, labelText: labelText, reversed: reversed, disabled: disabled })),
        react_1["default"].createElement(InputSearch_1.InputSearch, __assign({ "aria-label": !showVisibleLabel ? labelText : undefined, id: id, placeholder: placeholder, disabled: disabled, value: value, reversed: reversed, secondary: secondary, onClear: onClear, loading: loading }, genericInputProps))));
};
exports["default"] = SearchField;
//# sourceMappingURL=SearchField.js.map